// TODO: expose these from @alltrails/shared
export const PRIMARY_GRAY_SHADE = '#A6A6A6';
export const SECONDARY_GRAY_SHADE = '#5A5A5A';
export const SECONDARY_LIGHT_GRAY_TINT = '#f2f2f2';